<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VueCqrs from "@cqrs/vue-component-cqrs";

    @Component
    export default class SessionExpiredPage extends mixins(PageBase, VueCqrs) {
        mounted() {
            this.setTitle("Session expired");
        }
    }
</script>

<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12">
                <div class="container small" style="margin-top: 30px;" data-test-id="SigninView">
                    <div class="border-box">
                        <h3 class="fg-color-blue">Your session expired</h3>
                        <p>
                            <a :href="`/organizations/sessions/new?returnUrl=${$route.params.returnUrl}`" class="btn btn-warning">Start a new session</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
